import { forEachElement } from '../common/utils/dom';

function removeSlotsWithoutContent() {
  forEachElement(document.querySelectorAll('.base-slot > p'), (element) => {
    if (element.textContent && element.textContent.trim() !== '') {
      element.parentElement.classList.remove('base-slot--hidden');
    }
  });
}

export default function init() {
  removeSlotsWithoutContent();
  $('body').on('minicart:show cart:do-after-update', () =>
    removeSlotsWithoutContent()
  );
}
